/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StoreProfileDetailsHourRange } from './StoreProfileDetailsHourRange';
import {
    StoreProfileDetailsHourRangeFromJSON,
    StoreProfileDetailsHourRangeFromJSONTyped,
    StoreProfileDetailsHourRangeToJSON,
    StoreProfileDetailsHourRangeToJSONTyped,
} from './StoreProfileDetailsHourRange';

/**
 * 
 * @export
 * @interface StoreProfileDay
 */
export interface StoreProfileDay {
    /**
     * 
     * @type {Array<StoreProfileDetailsHourRange>}
     * @memberof StoreProfileDay
     */
    hours: Array<StoreProfileDetailsHourRange>;
    /**
     * 
     * @type {boolean}
     * @memberof StoreProfileDay
     */
    isOpen: boolean;
}

/**
 * Check if a given object implements the StoreProfileDay interface.
 */
export function instanceOfStoreProfileDay(value: object): value is StoreProfileDay {
    if (!('hours' in value) || value['hours'] === undefined) return false;
    if (!('isOpen' in value) || value['isOpen'] === undefined) return false;
    return true;
}

export function StoreProfileDayFromJSON(json: any): StoreProfileDay {
    return StoreProfileDayFromJSONTyped(json, false);
}

export function StoreProfileDayFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfileDay {
    if (json == null) {
        return json;
    }
    return {
        
        'hours': ((json['hours'] as Array<any>).map(StoreProfileDetailsHourRangeFromJSON)),
        'isOpen': json['isOpen'],
    };
}

export function StoreProfileDayToJSON(json: any): StoreProfileDay {
    return StoreProfileDayToJSONTyped(json, false);
}

export function StoreProfileDayToJSONTyped(value?: StoreProfileDay | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hours': ((value['hours'] as Array<any>).map(StoreProfileDetailsHourRangeToJSON)),
        'isOpen': value['isOpen'],
    };
}

